import { type FC } from "react";
import { Loader2Icon, CheckCircle2Icon, DatabaseIcon } from "lucide-react";
import { Card } from "../ui/card";
import { cn } from "@/lib/utils";

// Custom tool component for get_source_tables tool
const SourceTablesToolCallComponent: FC<{
  toolName: string;
  argsText: string;
  result?: unknown;
  status?: { type: "running" | "complete" | "incomplete"; reason?: string };
  args?: any;
  toolCallId?: string;
  [key: string]: any;
}> = ({ argsText, result, status }) => {
  const isRunning = status?.type === "running" || (status === undefined && result === undefined);
  const isError = status?.type === "incomplete" && status?.reason === "error";
  const isComplete = status?.type === "complete" && !isError;

  // Parse args for database/schema filter
  let filterText = "";
  try {
    const parsedArgs = typeof argsText === 'string' ? JSON.parse(argsText) : argsText;
    if (parsedArgs?.database) {
      filterText = `in ${parsedArgs.database}`;
      if (parsedArgs?.schema_name) {
        filterText += `.${parsedArgs.schema_name}`;
      }
    }
  } catch (e) {
    // Parsing failed
  }

  // Parse result to get table count
  let tableCount = 0;
  if (result !== undefined && isComplete) {
    try {
      const parsed = typeof result === 'string' ? JSON.parse(result) : result;
      tableCount = (parsed?.sources || []).length;
    } catch (e) {
      // Parsing failed
    }
  }

  return (
    <Card>
      <div className={cn(
        "p-3",
        isRunning ? "bg-primary/10" : "bg-muted/50"
      )}>
        <div className="flex items-center gap-2">
          {isRunning ? (
            <>
              <Loader2Icon className="h-4 w-4 text-primary animate-spin flex-shrink-0" />
              <span className="text-sm">Loading available source tables{filterText ? ` ${filterText}` : ""}...</span>
            </>
          ) : isComplete ? (
            <>
              <CheckCircle2Icon className="h-4 w-4 text-success flex-shrink-0" />
              <span className="text-sm">Found {tableCount} source tables{filterText ? ` ${filterText}` : ""}</span>
            </>
          ) : (
            <>
              <DatabaseIcon className="h-4 w-4 text-muted-foreground flex-shrink-0" />
              <span className="text-sm text-muted-foreground">Querying source tables...</span>
            </>
          )}
        </div>
      </div>
    </Card>
  );
};

export const SourceTablesToolCall = SourceTablesToolCallComponent as React.ComponentType<any>;
